import {gql} from "@irati/utils/gql"

const mutation = gql`
  mutation DeleteSSOUser($userId: ID!) {
    deleteSSOUser(userId: $userId)
  }
`

export default mutation
